<template>
  <div class="colour-swatches">
    <label v-for="item in items" :key="item.id" class="colour-swatch">
      <input
        class="colour-swatch__input"
        type="checkbox"
        :checked="item.selected"
        @change="$emit('change', item)"
      />
      <span
        class="colour-swatch__circle"
        :class="{
          'colour-swatch__circle--border': swatchFor(item).border,
          'colour-swatch__circle--animal': swatchFor(item).pattern === 'animal',
        }"
        :style="circleStyle(item)"
      />
      <span class="colour-swatch__label">
        {{ item.label }} ({{ item.count }})
      </span>
    </label>
  </div>
</template>

<script>
import { getFilterColourSwatch } from "@/helpers/filterColourSwatches";
import animalSwatch from "@/assets/images/filter-swatch-animal.jpg";

export default {
  name: "ColourSwatchOptions",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change"],
  methods: {
    swatchFor(item) {
      return getFilterColourSwatch(item.label);
    },
    circleStyle(item) {
      const swatch = this.swatchFor(item);

      if (swatch.pattern === "animal") {
        return { backgroundImage: `url(${animalSwatch})` };
      }
      if (swatch.gradient) return { backgroundImage: swatch.gradient };
      return { backgroundColor: swatch.color };
    },
  },
};
</script>

<style lang="scss" scoped>
.colour-swatches {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}

.colour-swatch {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 50%;
  margin: 0;
  padding: 8px 8px 8px 0;
  cursor: pointer;
}

.colour-swatch__input {
  @extend .u__visually-hidden;

  &:checked + .colour-swatch__circle {
    box-shadow: 0 0 0 1px #fff, 0 0 0 2px #111;
  }

  &:checked + .colour-swatch__circle--border {
    box-shadow: inset 0 0 0 1px #e4e4e4, 0 0 0 1px #fff, 0 0 0 2px #111;
  }
}

.colour-swatch__circle {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #d9d9d9;

  &--border {
    box-shadow: inset 0 0 0 1px #e4e4e4;
  }

  &--animal {
    background-color: #c9a36a;
    background-position: center;
    background-size: cover;
  }
}

.colour-swatch__label {
  @include utility-body(14px);
  line-height: 1.35;
  color: $color-black;
}
</style>
